///<reference path="./Logging.js"/>
if (!!window.publicMethods) throw "publicMethods already defined";
var publicMethods = [
  "dojoConfig",
  "getDateFormat",
  "getTimeFormat",
  "contextMessaging",
  "IsMingle",
  "parseFormat",
  "_DeepPagePath",
  "format",
  "getDateFromFormat",
  "emptyDateFormat",
  "getDateTimePattern",
  "FormatLocaleDate",
  "_WaitMsg",
  "_ShowValidationMessage",
  "PublishContextMessage",
  "_Prefs",
  "AutoCompleteSettings",
  "AppletIdToViewId",
  "iQuery",
  "showOrHideTabPreview",
  "_Locale",
  "_Data",
  "common",
  "Resx",
  "convertToType",
  "_ClientPath",
  "_DateFormat",
  "_TimeFormat",
  "_PhoneFormat",
  "_CurrencyDecimalSeparator",
  "_CurrencyGroupSeparator",
  "_NumberDecimalSeparator",
  "_NumberGroupSeparator",
  "_CurrencySymbol",
  "resx",
  "TagBuilder",
  "isModal",
  "AddChildWindow",
  "AddChildWindowToMainFrame",
  "SetInsideClose",
  "closeInternal",
  "OnClose",
  "cleanCloseChild",
  "closeChildren",
  "log",
  "openModalChild",
  "SetAppPath",
  "setWaitPrompt",
  "showWaitMsg",
  "showManualCancel",
  "manualCancel",
  "hideWaitMsg",
  "waitForView",
  "startNewEvent",
  "findEM",
  "addEvent",
  "addEventEx",
  "addEventExp",
  "getDataIndex",
  "addDownloadOnlyData",
  "addDropDownData",
  "addAttachments",
  "addControlData",
  "addData",
  "addGrid",
  "addTabPane",
  "containsTabPane",
  "addSearchRange",
  "getNodeValue",
  "isEmpty",
  "addNodeData",
  "setControlValue",
  "setControlValueDoc",
  "setControlAttribute",
  "setControlStyle",
  "SetCurrentTab",
  "collectChildData",
  "collectBindData",
  "buildDataList",
  "sendEvents",
  "isViewReady",
  "isMenuReady",
  "GetGlobalData",
  "sendCustomRequest",
  "eventAdded",
  "startMaintainSessionTimerThread",
  "stopMaintainSessionTimerThread",
  "resetSessionThread",
  "pingSession",
  "sendPingRequest",
  "queueEvent",
  "queueEventObj",
  "setChild",
  "AddModuleMenuOptions",
  "jumpToFormCodes",
  "hideSignOutButton",
  "getMenuForm",
  "finishViewLoad",
  "finishViewLoadWithHeaderTitle",
  "finishView",
  "finishViewWithHeaderTitle",
  "viewReadyState",
  "viewReadyStateWithHeaderTitle",
  "xmlEscape",
  "urlEscape",
  "xmlUnescape",
  "htmlUnescape",
  "zoom",
  "zoomEx",
  "ShowHeader",
  "GetControl",
  "DownloadFile",
  "RedirectToDownloadFrame",
  "GetCurrentView",
  "RemoveFromCache",
  "GetIFrameViewDocument",
  "GetIFrameView",
  "GetViewDocument",
  "GetView",
  "getDummyView",
  "GetHomeView",
  "GetCtrlVid",
  "GetCtrlStringRef",
  "IsDialog",
  "SetNavi",
  "GetNaviBar",
  "HideHeader",
  "GetHeaderTitle",
  "SetCleanFlag",
  "SetCheckCleanFlag",
  "SetCloseDelegate",
  "RunCloseDelegate",
  "ResizeAllViews",
  "ToggleMenuVisibility",
  "SetAutoHide",
  "AutoHideMenu",
  "HideMenu",
  "ShowMenu",
  "MenuClick",
  "menuLoadView",
  "getTabColor",
  "DeselectCurrentTab",
  "SelectTab",
  "isChildWindow",
  "AddTask",
  "RemoveSpecificTask",
  "RemoveCurrentTask",
  "ClearAllTabs",
  "ClearAllTasksExceptFirst",
  "SetCurrentTabName",
  "SetTabName",
  "SetTabNameEx",
  "SetCurrentTabTitle",
  "clientException",
  "readyForError",
  "fireClientErrorEvent",
  "openErrorMsg",
  "openHansenDialog",
  "openMessageBox",
  "SavePreferences",
  "getPrefsXml",
  "constructPrefs",
  "setControlPrefValue",
  "addImgCache",
  "getCachedImage",
  "MapDrawerCallProxy",
  "getLocaleSpecifier",
  "handleKeyDownGlobal",
  "getCompositeDisplay",
  "getCompositeKey",
  "makeComposite",
  "SystemEvents",
  "showModalDiv",
  "applyPublicFunctions",
  "_AppPath"
];
function removePublicFunctions(target) {
  var name;
  for (var i = 0; i < publicMethods.length; i++) {
    name = publicMethods[i];
    delete target[name];
  }
  target.instance = null;
}
function applyPublicFunctions(target,moniker) {
  for (var i = 0; i < publicMethods.length; i++) {
    var name_1 = publicMethods[i];
    target[name_1] = instance[name_1];
  }
  target.instance = instance;
  target.moniker = moniker;
  if (target.frameElement.id == "viewTab")
  {
	  if (!moniker)
	  {
		  var src = target.frameElement.getAttribute("src");
		  if (src)
		  {
			  var match = src.match(/monk=(.+?)&/);
			  if (match && match.length > 1)
			  {
				  moniker = match[1];
			  }
		  }
	  }
	  if (!target.frameElement.getAttribute("data-auto-uid"))
	  {
		target.frameElement.setAttribute("data-auto-uid", moniker);
	  }
  }
}
var applyToFrame = function(name,moniker) {
  var frame = window.frames[name];
  if (!frame) {
    setTimeout(function() {
      applyToFrame(name,moniker);
    }, 5);
    return;
  }
  // inconcisently assigning this method to window and frame (see menu.js, taskmanagement.js)
  frame.frameElement.applyPublicFunctions = applyPublicFunctions;
  frame.frameElement.moniker = moniker;
  frame.frameElement.setAttribute("data-auto-moniker", moniker);
};
// Bootstrap the frames
applyToFrame("cblock", window.moniker);
applyToFrame("menuAndView", window.moniker);
